/* ============================================================
   PERSONALIZED PREMIUM COFFEE MUG - FRONT VIEW FABRIC.JS CUSTOMIZER
   Canvas/source image: 1536 x 1024 (personalized_coffee_mug_background.png)
   Printable/customizable area: main straight body only, BELOW the
   cap/lid and neck band, and above the base curve. The lid/cap and
   handle are NOT part of the editable area.
   Two Style variants (Black / Silver) swap the background photo -
   the customizable PANEL rectangle is identical for both, since
   both photos are framed the same way.
   No 3D / no perspective transformation.
============================================================ */

function showFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').show();
}

function hideFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').fadeOut(300);
}

var cWidth = 1536;
var cHeight = 1024;
var halfWidth = cWidth / 2;
var halfHeight = cHeight / 2;

var loader = jQuery('#customLoader');
var loadedObject = null;
var wMark = null;
var svgMrk = null;

/*
  IMPORTANT:
  The supplied mug image is 1536 x 1024.
  This rectangle covers only the main cylindrical body of the mug -
  measured to sit below the cap/neck seam, above the base curve, and
  clear of the handle - matching the "only below the cap" area the
  reference crop showed. Verified against BOTH the black and silver
  photos - they're framed identically, so one PANEL works for both.
*/
var PANEL = {
  left: 467,
  top: 372,
  width: 422,
  height: 525
};
PANEL.right = PANEL.left + PANEL.width;
PANEL.bottom = PANEL.top + PANEL.height;
PANEL.centerX = PANEL.left + PANEL.width / 2;
PANEL.centerY = PANEL.top + PANEL.height / 2;

function makePanelClipPath() {
  return new fabric.Rect({
    left: PANEL.left,
    top: PANEL.top,
    width: PANEL.width,
    height: PANEL.height,
    absolutePositioned: true,
    rx: 8,
    ry: 8
  });
}

/* ==========================================================
   COLOR / STYLE SWAP (Black / Silver)
   #base1 = black photo, #base2 = silver photo - both rendered as
   hidden <img data-src="..."> elements by
   personalized_coffee_mug_variant.liquid. Selecting the "Style"
   variant swaps starBackground's actual image without touching
   anything the customer has already placed on the canvas.
========================================================== */
function loadImage(url) {
  if (!url) return;
  fabric.Image.fromURL(url, function (img) {
    starBackground.setElement(img.getElement());
    starBackground.scaleToWidth(cWidth);
    starBackground.setCoords();
    window['canvas2'].renderAll();
    starBackground.scaleToWidth(window['canvas2'].width);
    starBackground.setCoords();
    window['canvas2'].renderAll();
    starBackground.set({ left: 0, top: 0 });
    if (window['canvas2']) window['canvas2'].renderAll();
  }, { crossOrigin: 'anonymous' });
}

var starimage = document.querySelector('#stars_background');
var starBackground = new fabric.Image(starimage, {
  left: 0,
  top: 0,
  selectable: false,
  evented: false,
  objectCaching: false
});

starBackground.scaleToWidth(cWidth);

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight,
  preserveObjectStacking: true,
  selection: true
});

window['canvas2'].add(starBackground);
starBackground.sendToBack();

showFabricCanvasLoader();
addModify(window['canvas2']);

var canvasInitialRenderDone = false;
function markCanvasReady() {
  if (canvasInitialRenderDone) return;
  canvasInitialRenderDone = true;
  hideFabricCanvasLoader();
}

function clampToPanel(obj) {
  if (!obj || !obj.getCenterPoint) return;

  var margin = 35;
  var minX = PANEL.left - margin;
  var maxX = PANEL.right + margin;
  var minY = PANEL.top - margin;
  var maxY = PANEL.bottom + margin;
  var center = obj.getCenterPoint();

  var x = Math.min(Math.max(center.x, minX), maxX);
  var y = Math.min(Math.max(center.y, minY), maxY);

  if (x !== center.x || y !== center.y) {
    obj.setPositionByOrigin(new fabric.Point(x, y), 'center', 'center');
    obj.setCoords();
  }
}

function restackLayers(canvas) {
  if (starBackground) starBackground.sendToBack();
  if (window.uploadedImageObj) window.uploadedImageObj.bringToFront();
  if (window['text1Page']) window['text1Page'].bringToFront();
  if (window['text55Page']) window['text55Page'].bringToFront();
  canvas.renderAll();
}

(function () {
  function initMugCustomizer() {
    var canvas2 = window['canvas2'];
    if (!canvas2) return;

    /* Style (color) swatch change - matches "Black"/"Silver" (or
       anything containing "silver", case-insensitive) against the
       real Shopify variant option label, so exact capitalization
       doesn't need to match perfectly. */
    jQuery(document).on('change', 'input[name="Color"]', function () {
      var selectedVal = (jQuery(this).val() || '').toLowerCase();
      if (selectedVal.indexOf('silver') !== -1) {
        loadImage(jQuery('#base2 img').attr('data-src'));
      } else {
        loadImage(jQuery('#base1 img').attr('data-src'));
      }
    });

    canvas2.on('object:moving', function (e) {
      if (e.target && e.target !== starBackground && e.target !== window['text55Page']) {
        clampToPanel(e.target);
      }
    });

    /* ==========================================================
       CUSTOMER TEXT
       Multi-line textarea; customer can drag, resize and rotate.
       splitByGrapheme lets a long run of text with NO spaces still
       wrap onto the next line instead of overflowing the panel in
       one line and getting clipped.
    ========================================================== */
    window['text1Page'] = new fabric.Textbox('Your\nDesign\nHere', {
      left: PANEL.centerX,
      top: PANEL.centerY,
      originX: 'center',
      originY: 'center',
      width: PANEL.width * 0.82,
      fontSize: 56,
      minWidth: 80,
      fontFamily: 'Dancing Script',
      fill: '#f5f5f5',
      textAlign: 'center',
      editable: false,
      lockUniScaling: false,
      lockScalingX: false,
      lockScalingY: false,
      hasControls: true,
      splitByGrapheme: true,
      clipPath: makePanelClipPath(),
      objectCaching: false
    });

    canvas2.add(window['text1Page']);

    var fontName1 = window['text1Page'].fontFamily;
    jQuery('.choose_font1').val("'" + fontName1 + "'").trigger('change');

    var textInput = document.getElementById('text_1');
    if (textInput) {
      textInput.addEventListener('focus', function () {
        if (window['text1Page'].text === 'Your\nDesign\nHere') {
          window['text1Page'].set('text', '');
          canvas2.renderAll();
        }
      });

      textInput.addEventListener('input', function (e) {
        var lines = e.target.value.split('\n').slice(0, 6);
        e.target.value = lines.join('\n');
        window['text1Page'].set({ text: e.target.value });
        window['text1Page'].setCoords();
        canvas2.renderAll();
      });
    }

    jQuery(document).on('change', '.fontFamily', function () {
      var value = this.value || 'Dancing Script';
      var canvasId = jQuery(this).data('canvas');
      var objId = jQuery(this).data('obj');

      if (window[canvasId] && window[objId]) {
        window[objId].set('fontFamily', value.replace(/'/g, ''));
        window[canvasId].renderAll();
      }
    });

    var colorInput = document.getElementById('text_color');
    if (colorInput) {
      colorInput.addEventListener('input', function (e) {
        window['text1Page'].set('fill', e.target.value);
        canvas2.renderAll();
      });
    }

    /* ==========================================================
       IMAGE / LOGO / STICKER UPLOAD
       One uploaded image at a time; drag / resize / rotate.
    ========================================================== */
    var uploadedImageObj = null;
    var imageUpload = document.getElementById('design_image_upload');
    var removeImageBtn = document.getElementById('removeDesignImage');

    if (imageUpload) {
      imageUpload.addEventListener('change', function (e) {
        var file = e.target.files && e.target.files[0];
        if (!file) return;

        var reader = new FileReader();
        reader.onload = function (evt) {
          fabric.Image.fromURL(evt.target.result, function (img) {
            if (uploadedImageObj) canvas2.remove(uploadedImageObj);

            var maxW = PANEL.width * 0.82;
            var maxH = PANEL.height * 0.72;
            var scale = Math.min(maxW / img.width, maxH / img.height);

            img.set({
              left: PANEL.centerX,
              top: PANEL.centerY,
              originX: 'center',
              originY: 'center',
              scaleX: scale,
              scaleY: scale,
              selectable: true,
              evented: true,
              lockUniScaling: false,
              clipPath: makePanelClipPath(),
              objectCaching: false
            });

            uploadedImageObj = img;
            window.uploadedImageObj = img;
            canvas2.add(img);
            restackLayers(canvas2);
            canvas2.setActiveObject(img);
            canvas2.renderAll();

            if (removeImageBtn) removeImageBtn.style.display = 'inline-block';
          });
        };
        reader.readAsDataURL(file);
      });
    }

    if (removeImageBtn) {
      removeImageBtn.addEventListener('click', function () {
        if (uploadedImageObj) {
          canvas2.remove(uploadedImageObj);
          uploadedImageObj = null;
          window.uploadedImageObj = null;
        }
        if (imageUpload) imageUpload.value = '';
        removeImageBtn.style.display = 'none';
        canvas2.renderAll();
      });
    }

    /* ==========================================================
       BRAND WATERMARK - only the site watermark, not part of the
       customer's editable design.
    ========================================================== */
    window['text55Page'] = new fabric.Text('@tasweer.com.pk', {
      left: cWidth - 145,
      top: cHeight - 35,
      fontSize: 16,
      fontFamily: 'Baloo2',
      fill: '#777',
      lockMovementX: true,
      lockMovementY: true,
      hasControls: false,
      selectable: false,
      evented: false
    });

    canvas2.add(window['text55Page']);
    restackLayers(canvas2);
    canvas2.renderAll();
    markCanvasReady();

    /* ==========================================================
       ADD TO CART / EXPORT
    ========================================================== */
    jQuery(document).on('click', '#download', function () {
      loader.removeClass('hidden');
      canvas2.discardActiveObject();
      canvas2.renderAll();

      setTimeout(function () {
        var id = ['canvas2'];
        var canvas = canvas2;
        var size = 406;

        // loadMarkAsync only RESOLVES once window['canvas2t'] has actually
        // been written (watermark SVG is loaded asynchronously by Fabric).
        // Waiting for this promise avoids sending an incomplete request to
        // save_order.php (that was the bug that caused a broken/missing
        // "Extra Image" on the lighter product - fixed the same way here).
        loadMarkAsync(id, canvas, size).then(function () {
          if (loadedObject) {
            canvas.remove(loadedObject);
            loadedObject = null;
          }

          // Reset to a known 1:1 zoom so PANEL's coordinates match real
// canvas pixels exactly, then render everything at that zoom.
canvas.setZoom(1);
canvas.setDimensions({ width: cWidth, height: cHeight });

// Background aur watermark ko hide kiya taake print file
// 100% TRANSPARENT PNG bane.
if (starBackground) starBackground.visible = false;
if (window['text55Page']) window['text55Page'].visible = false;
canvas.renderAll();

// Crop with Mobile Retina scaling fix
var cropMultiplier = 4000 / cWidth;
var sourceCanvasEl = canvas.lowerCanvasEl || canvas.getElement();

// Mobile retina / high-DPI screens (2x, 3x) scaling factor
var scaleX = sourceCanvasEl.width / cWidth;
var scaleY = sourceCanvasEl.height / cHeight;

var sx = Math.round(PANEL.left * scaleX);
var sy = Math.round(PANEL.top * scaleY);
var sw = Math.round(PANEL.width * scaleX);
var sh = Math.round(PANEL.height * scaleY);

var cropCanvasEl = document.createElement('canvas');
cropCanvasEl.width = Math.round(PANEL.width * cropMultiplier);
cropCanvasEl.height = Math.round(PANEL.height * cropMultiplier);

var cropCtx = cropCanvasEl.getContext('2d');
cropCtx.clearRect(0, 0, cropCanvasEl.width, cropCanvasEl.height);

cropCtx.drawImage(
  sourceCanvasEl,
  sx, sy, sw, sh,
  0, 0, cropCanvasEl.width, cropCanvasEl.height
);

window['canvas2exported'] = cropCanvasEl.toDataURL('image/png');

// Screen display ke liye background aur watermark wapas show kar diya
if (starBackground) starBackground.visible = true;
if (window['text55Page']) window['text55Page'].visible = true;
canvas.renderAll();

          console.log('[mug] cropped export size (px):', cropCanvasEl.width, 'x', cropCanvasEl.height,
            '- from panel', PANEL.left, PANEL.top, PANEL.width, PANEL.height);

          var enterText = window['text1Page'] ? window['text1Page'].text : '';
          var textFont = jQuery('.choose_font1 option:selected').val() || '';
          var textColor = jQuery('#text_color').val() || '#1a1a1a';
          var additionalInfo = jQuery('.tShirtImg textarea').val() || '';

          if (typeof canvasBlock === 'function') canvasBlock(canvas);

          function finishAddToCart(previewId, extraImg1) {
            jQuery('#previewImg').val(previewId || '');
            jQuery('#preExtraImg').val(extraImg1 || '');
            jQuery('#enterText').val(enterText);
            jQuery('#textFont').val(textFont);
            jQuery('#textColor').val(textColor);
            jQuery('#addInfo').val(additionalInfo);

            jQuery('.product-form__buttons .product-form__submit').trigger('click');
            loader.addClass('hidden');
          }

          // Safety net: if the upload service is slow/unresponsive, don't
          // leave the customer stuck - still add the item to cart.
          var cartAddedAlready = false;
          var safetyTimer = setTimeout(function () {
            if (cartAddedAlready) return;
            cartAddedAlready = true;
            finishAddToCart('', '');
          }, 15000);

          console.log('[mug] sending to save_order.php - temp_image length:',
            (window['canvas2t'] || '').length,
            'original_image length:', (window['canvas2exported'] || '').length);

          fetch('//technology-architects.com/tasweer-modules/save_order.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              temp_image: window['canvas2t'],
              original_image: window['canvas2exported']
            })
          })
            .then(function (response) {
              console.log('[mug] save_order.php responded with status:', response.status, response.statusText);
              if (!response.ok) {
                return response.text().then(function (text) {
                  console.error('[mug] save_order.php error body:', text);
                  throw new Error('save_order.php returned ' + response.status);
                });
              }
              return response.json();
            })
            .then(function (data) {
              console.log('[mug] save_order.php parsed response:', data);
              clearTimeout(safetyTimer);
              if (cartAddedAlready) return;
              cartAddedAlready = true;

              // properties[extra_image] is what the cart actually renders
              // as an <img> - it needs a real absolute URL. previewId maps
              // to properties[ID], a plain reference id - leave it exactly
              // as the server sent it.
              var previewId = data && data[0] ? data[0] : '';
              var extraImg1 = data && data[1] ? data[1] : '';
              extraImg1 = toAbsoluteUploadUrl(extraImg1);

              console.log('[mug] properties being sent to cart -> ID:', previewId, '| extra_image:', extraImg1);

              finishAddToCart(previewId, extraImg1);
            })
            .catch(function (error) {
              console.error('[mug] Error uploading mug design:', error);
              clearTimeout(safetyTimer);
              if (cartAddedAlready) return;
              cartAddedAlready = true;
              finishAddToCart('', '');
            });
        });
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMugCustomizer);
  } else {
    initMugCustomizer();
  }
})();

/* ============================================================
   RESPONSIVE DISPLAY
============================================================ */
function canvasMakeImg(canvas, zoom) {
  var newZoomLevel = zoom / cWidth;
  setZoomMask(canvas, newZoomLevel);
}

function canvasBlock(canvas) {
  if (!canvas) return;
  var zoom = jQuery('.product__media-outer').width();
  if (!zoom) return;
  var newZoomLevel = zoom / cWidth;
  setZoomMask(canvas, newZoomLevel);
}

function setZoomMask(canvas, newZoomLevel) {
  if (!canvas || !newZoomLevel) return;

  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width: cWidth * newZoomLevel,
    height: cHeight * newZoomLevel
  });
  canvas.renderAll();

  var wrapperEl = canvas.wrapperEl;
  if (wrapperEl) {
    wrapperEl.style.marginLeft = 'auto';
    wrapperEl.style.marginRight = 'auto';
    wrapperEl.style.display = 'block';
  }
}

function addModify(canvas) {
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;
  canvas.renderOnAddRemove = false;

  canvas.on('object:added', function () {
    canvas.renderAll();
  });

  canvas.on('object:modified', function () {
    canvas.renderAll();
  });
}

jQuery(window).on('resize', function () {
  canvasBlock(window['canvas2']);
});

jQuery(window).on('load', function () {
  canvasBlock(window['canvas2']);
});

/* ============================================================
   SITE WATERMARK EXPORT HELPERS
============================================================ */

/* Kept for backwards compatibility - NOT used by the Add to Cart flow
   any more because it doesn't let the caller know when the async SVG
   watermark has actually finished loading (see loadMarkAsync below). */
function loadMark(id, canvas, size) {
  wMark = document.getElementById('wm_collage');
  if (!wMark) {
    canvasMakeImg(canvas, size);
    window[id + 't'] = canvas.toDataURL('image/png');
    return;
  }

  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function (objects, options) {
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false,
      evented: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
    canvasMakeImg(canvas, size);
    window[id + 't'] = canvas.toDataURL('image/png');
  });
}

/* Promise version of loadMark(). window['canvas2t'] is guaranteed to be
   set (a real PNG data URL, not undefined/stale) by the time .then() runs -
   this is what the Add to Cart handler waits on before it reads
   window['canvas2t'] and sends it to save_order.php. */
function loadMarkAsync(id, canvas, size) {
  return new Promise(function (resolve) {
    wMark = document.getElementById('wm_collage');
    if (!wMark) {
      canvasMakeImg(canvas, size);
      window[id + 't'] = canvas.toDataURL('image/png');
      resolve();
      return;
    }

    svgMrk = wMark.innerHTML;
    fabric.loadSVGFromString(svgMrk, function (objects, options) {
      loadedObject = fabric.util.groupSVGElements(objects, options);
      loadedObject.scaleToWidth(cWidth);
      loadedObject.set({
        left: cWidth / 2,
        top: cHeight / 2,
        originX: 'center',
        originY: 'center',
        objectCaching: false,
        selectable: false,
        evented: false
      });
      canvas.add(loadedObject);
      loadedObject.bringToFront();
      loadedObject.setCoords();
      canvas.renderAll();
      canvasMakeImg(canvas, size);
      window[id + 't'] = canvas.toDataURL('image/png');
      resolve();
    });
  });
}

function removeMark(canvas, size) {
  if (loadedObject) {
    canvas.remove(loadedObject);
    loadedObject = null;
  }
  canvasMakeImg(canvas, size);
}

/* If save_order.php ever hands back a bare filename or a site-relative
   path instead of a full URL, an <img src="..."> built from it in the
   cart would 404 (broken image) even though the upload itself worked -
   the browser resolves it against the CURRENT (Shopify) domain, not
   technology-architects.com. Make sure whatever we store is absolute. */
function toAbsoluteUploadUrl(value) {
  if (!value) return '';
  if (/^(https?:)?\/\//i.test(value) || /^data:/i.test(value)) return value;
  var path = value.charAt(0) === '/' ? value : '/tasweer-modules/' + value;
  return '//technology-architects.com' + path;
}